import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { TouchableOpacity, View } from 'react-native'
import styled from 'styled-components'
import { Button, useButtonHandlers } from '../../../../elements/controls/index.js'
import Icon from '../../../../elements/images/Icon/index.js'
import { CloseButton } from '../../../../elements/layout/Modal/index.js'
import { Row } from '../../../../elements/layout/index.js'
import { Text } from '../../../../elements/typography/index.js'
import { media } from '../../../../style/media.js'
import { FilmPoster } from '../../../content/FilmPoster/FilmPoster'
import messages from '../../messages.js'

export const Container = styled(View)`
  margin-top: ${(props) => props.theme.spacing.medium}px;

  ${media.md`
    margin-top: ${(props) => props.theme.spacing.larger}px;
  `}
`

export const Content = styled(View)`
  justify-content: space-between;
  background-color: ${(props) => props.theme.colors.grayLight}a;
  padding-top: ${(props) => props.theme.spacing.small}px;
  padding-bottom: ${(props) => props.theme.spacing.small}px;
  padding-left: ${(props) => props.theme.spacing.medium}px;
  padding-right: ${(props) => props.theme.spacing.larger}px;

  ${media.md`
    padding-top: ${(props) => props.theme.spacing.medium}px;
    padding-bottom: ${(props) => props.theme.spacing.medium}px;
    padding-left: ${(props) => props.theme.spacing.larger}px;
    padding-right: ${(props) => props.theme.spacing.xlarge}px;
  `}
`

export const Heading = styled(Text)`
  font-weight: ${(props) => props.theme.fontWeights.bold};
  font-family: ${(props) => props.theme.fontFamilies.base};

  ${media.md`
    font-size: ${(props) => props.theme.fontSizes.large}px;
    line-height: ${(props) => props.theme.fontSizes.large * 1.3}px;
  `}
`

const ModalCloseButton = styled(CloseButton)`
  top: ${(props) => props.theme.spacing.xsmall}px;
  right: ${(props) => props.theme.spacing.xxsmall}px;
`

export const NextRecommendation = ({ nextRecommendation, onViewDetails, posterWidth }) => {
  const { handlers } = useButtonHandlers()

  const [hidden, setHidden] = useState(false)

  return hidden ? null : (
    <Container>
      <Row justifyContent="flex-end">
        <FilmPoster width={posterWidth} item={nextRecommendation} />

        <Content>
          <Heading textAlign="center">
            <FormattedMessage {...messages.nextRecommendHeading} />
          </Heading>

          <Button
            variant="primary"
            intlMsg={messages.nextRecommendPlay}
            onPress={() => handlers.playFeature(nextRecommendation, 'replace')}
            mb="none"
          />
          <Button
            variant="white"
            intlMsg={messages.nextRecommendDetails}
            titleColor="black"
            onPress={() => (onViewDetails ?? handlers.viewDetails)(nextRecommendation, 'replace')}
            mb="none"
          />

          <ModalCloseButton scale={0.65}>
            <TouchableOpacity onPress={() => setHidden(true)}>
              <Icon name="close" color="grayLighte" scale={0.65} />
            </TouchableOpacity>
          </ModalCloseButton>
        </Content>
      </Row>
    </Container>
  )
}
